/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { PreSetupTemplateWizard } from './PreSetupTemplateWizard';
